import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TaskEstimateRowContextProvider from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/TaskEstimateRowContextProvider';
import { ChangeTaskResourceDialog } from '~/modules/tasks/components';
import { useTaskEstimateRowContextDataBuilder } from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/hooks';
import { useProjectContext } from '~/modules/resourcing/common/contexts';

export const ChangeTaskResourceConfirmationDialog = ({
  changeTaskResourceDialogOpen,
  closeChangeTaskResourceDialog,
  onChangeTaskResourceSuccess,
  task,
  user
}) => {
  const {
    project,
    projectObjectPermissions: { canViewCost }
  } = useProjectContext();
  const {
    loading,
    taskDetail,
    taskResourceEstimate
  } = useTaskEstimateRowContextDataBuilder({
    projectId: project.id,
    task,
    user,
    includeTaskResourceUserCostProgressSummary: canViewCost
  });

  const taskWithProject = useMemo(
    () => ({
      ...task,
      project: {
        id: project.id,
        slug: project.slug,
        resourceAllocationActions: project.resourceAllocationActions
      }
    }),
    [project, task]
  );

  return (
    <TaskEstimateRowContextProvider
      task={taskDetail}
      resourceEstimate={taskResourceEstimate}
      canEditTasks={false}
      canViewCost={canViewCost}
    >
      <ChangeTaskResourceDialog
        isLoading={loading}
        onClose={closeChangeTaskResourceDialog}
        onChangeTaskResourceSuccess={onChangeTaskResourceSuccess}
        open={changeTaskResourceDialogOpen}
        resourceEstimate={taskResourceEstimate}
        task={taskWithProject}
      />
    </TaskEstimateRowContextProvider>
  );
};

ChangeTaskResourceConfirmationDialog.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  user: PropTypes.object.isRequired,
  changeTaskResourceDialogOpen: PropTypes.bool.isRequired,
  closeChangeTaskResourceDialog: PropTypes.func.isRequired,
  onChangeTaskResourceSuccess: PropTypes.func.isRequired
};
